import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PendingDocument } from 'src/app/shared/models/pending-document.model';
import { ObjetoListaPlantillas } from 'src/app/models/ObjetoListaPlantillas';
import { InformeErroresProcAuto } from 'src/app/models/InformeErroresProcAuto';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  private storageKey = 'sdmInvoicerCurrentUser';

  constructor(private http: HttpClient) { }

  private GetQuery(query: string): any {

    const url = `${environment.apiUri}api/${query}`;

    return this.http.get<any>(url);
  }

  ObtenerListadoDocumentosParaProcesar(tipoFactura: number, secundario: string, nif: string, esTercero: boolean, usuarioTercero: string): Observable<PendingDocument[]> {

    let valorEnviar: string = secundario;
    if (tipoFactura == 2) {
      valorEnviar = nif;
    }
    let valorPrinTercero: string = usuarioTercero;
    if (usuarioTercero == "") {
      valorPrinTercero = "vacio";
    }

    return this.GetQuery(`templates/documentosParaPlantilla/${tipoFactura}/${valorEnviar}/${esTercero}/${valorPrinTercero}`);
  }

  EnviarEspacioEntrenamiento(nif: string, listaDocumentos: number[]): Observable<boolean> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.post<any>(`${environment.apiUri}api/templates/enviarEspacioEntrenamiento/${nif}`, listaDocumentos, { headers: header });
  }

  GrabarIdTemplate(nif: string) {

    var fechaActual = moment().format('YYYYMMDD');
    var quienGrabo = JSON.parse(localStorage.getItem(this.storageKey));

    return this.http.post<any>(`${environment.apiUri}api/templates/grabarIdTemplate/${nif}/${fechaActual}/${quienGrabo.email}`, '');
  }

  ReconocerDocumentosPendientes(nif: string) {

    return this.GetQuery(`templates/activarReconocimientoPendientes/${nif}`);
  }

  PuedeGenerarPlantilla(tipoDocumento: number, nif: string): Observable<boolean> {

    return this.GetQuery(`templates/puedeGenerarPlantilla/${tipoDocumento}/${nif}`);
  }

  ObtenerListadoPlantillasPendientes(tipoFactura: number, numeroDocs: number, numeroDocsMax: number): Observable<ObjetoListaPlantillas[]> {

    return this.GetQuery(`templates/cifsSinPlantillaParaCrear/${tipoFactura}/${numeroDocs}/${numeroDocsMax}`);
  }

  ObtenerListadoInformesFalloProcAuto(fecha: number, principal: string, secundario: string,
    difTotales: boolean, faltadatos: boolean, variasPaginas: boolean, numFactura: boolean, faltaIva: boolean,
    faltaCif: boolean, DocDuplicado: boolean): Observable<InformeErroresProcAuto> {

    return this.GetQuery(`templates/obtenerInformeProcesadasAutoError/${fecha}/${principal}/${secundario}/${difTotales}/${faltadatos}/${variasPaginas}/${numFactura}/${faltaIva}/${faltaCif}/${DocDuplicado}`);
  }

  ComprobarExistePlantillaConfig(tipoDoc: number, value: string): Observable<boolean> {

    return this.GetQuery(`templates/ComprobarExistePlantillaConfig/${tipoDoc}/${value}`);
  }


}
